export default { toggleChildHidden }

function toggleChildHidden(event) {
  let child = event.currentTarget.firstElementChild

  if (child) {
    child.classList.toggle("hidden");
  }
}
